import { Link } from "react-router-dom";

export const SUPPORT_EMAIL = "support@juxtaposedtidesmedia.com";

export function Footer() {
  return (
    <footer className="border-t border-border mt-12 bg-background/60">
      <div className="max-w-5xl mx-auto px-4 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-muted-foreground">
        <div className="flex items-center gap-3">
          <span>© {new Date().getFullYear()} Juxtaposed Tides Media</span>
          <span className="hidden sm:inline">·</span>
          <a href={`mailto:${SUPPORT_EMAIL}`} className="hover:text-primary">{SUPPORT_EMAIL}</a>
        </div>
        <nav className="flex flex-wrap items-center gap-x-4 gap-y-1">
          <Link to="/pricing" className="hover:text-primary">Pricing</Link>
          <Link to="/terms" className="hover:text-primary">Terms</Link>
          <Link to="/privacy" className="hover:text-primary">Privacy</Link>
          <Link to="/refund" className="hover:text-primary">Refunds</Link>
          <Link to="/contact" className="hover:text-primary">Contact</Link>
        </nav>
      </div>
    </footer>
  );
}
